var map = {
	"./CRMSAP Integration.svg": "cbUg",
	"./Carpathian Seagull.svg": "XHeJ",
	"./Cartovera.svg": "0GGH",
	"./Chernomorsk.svg": "IfX/",
	"./City Council Portal.svg": "K/rG",
	"./Diasoft.svg": "ayHP",
	"./Football Club Fan Application.svg": "SNGv",
	"./GudJob.svg": "4roy",
	"./IllichRealty.svg": "ylXI",
	"./Internet of Things.svg": "G63Y",
	"./Remote Assistance.svg": "ETSH",
	"./Russian Railways.svg": "gVvC",
	"./Service Doc.svg": "ufPB",
	"./Social App.svg": "TX83",
	"./Video Conference App.svg": "57uu",
	"./Video-conferencing Tool.svg": "2vYV",
	"./Wikigrads.svg": "ykV6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jRZ6";